/**
 * @global $
 * @global Backbone
 * @global gettext
 * @global userPasswordResetUrl
 */
(function () {
  "use strict";

  var PasswordResetConfirmationView = (window.PasswordResetConfirmationView =
    Backbone.View.extend({
      el: "#form_reset_password_confirmation",

      events: {
        submit: "submit",
      },

      initialize: function () {
        this.$success = this.$el.find(".success");
        this.$failure = this.$el.find(".failure");
        this.$loading = this.$el.find(".progress");
        $(".loading").removeClass("loading");
      },

      submit: function (e) {
        e.preventDefault();

        this.$loading.show();
        this.$failure.hide();
        this.$success.hide();

        var url =
          userPasswordResetConfirmationUrl +
          $("[name=uidb64]").val() +
          "-" +
          $("[name=token]").val() +
          "/";

        $.post(url, this.$el.serialize()).done(
          function (response) {
            response = JSON.parse(response);
            this.$loading.hide();

            if (response.success) {
              if (!response.domains) {
                this.$success.html(gettext("Password changed")).show();
              } else if (response.domains.length == 1) {
                window.location.href = "//" + response.domains[0];
              } else {
                var tpl = _.template($("#template-success").html());
                this.$success
                  .html(tpl(response))
                  .show()
                  .css({ "text-align": "left" });
                this.$el[0].reset();
              }
            } else {
              this.$failure
                .html(response.error.description.join("<br/>"))
                .show();
            }
          }.bind(this)
        );
      },
    }));
})();
